// in future we can switch to `react-device-detect`
const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
const isMobile = regex.test(navigator.userAgent)

export { isMobile }
